<template>

  <div class="main-container">

    <section  class="container mt-0 pt-0">

          <div class="row m-0 pb-3 p-0 bg-white">
            
            <div class="col-12 col-md-6 offset-md-3 mt-5">

              <div class="row mb-3">

                <div class="col-12 text-center">
                  <p class="font-weight-normal mb-1 mt-2 mb-0 pb-0 dark-text h5">Terms & Conditions</p>
                </div>
              </div>

            </div>

            <div id="chipin-form" class="col-12 col-md-6 offset-md-3 mt-2 text-center">

              <p class="text-center  font-weight-normal py-2 pb-0 mb-0 dark-text">TBD</p>

              <p class="text-center mt-3 pt-3">
                <b-button class="mb-4 px-5 py-2 rounded-btn" size="md" variant="info" @click="back()">
                  &nbsp;&nbsp;&nbsp;&nbsp;Back&nbsp;&nbsp;&nbsp;&nbsp;
                </b-button>
              </p>

            </div>


        </div>

      </section>

  </div>
  
</template>

<script>

  export default {
    name: 'ChipInTellMeMore',
    methods: {
      back() {
        this.$router.push('/')
      }
    }
  }
  
</script>

<style scoped>

  .light-grey-border {
    border: 2px solid #9B9B9B
  }

  .red-text {
    color: #FF0000;
  }
  
  .dark-text {
    color: #595959;
  }

  .super-small {
    font-size: 0.7em;
    color: #595959;
  }

  .rounded-btn {
    border-radius: 10px;
  }

</style>